import { CSSResult, unsafeCSS } from 'lit';
import MD3Style from '@dh-software/dh-components-themes/styles.css?inline';
import OrangeMD3Style from '@dh-software/dh-components-themes/defines/orange-light.css?inline';

export const themeStyles: Array<CSSResult> = [unsafeCSS(MD3Style), unsafeCSS(OrangeMD3Style)];
